import Editor from '@monaco-editor/react'
import styles from "./styles.module.less";
import { svgStrToDataUrl } from '@/common/svg'
import classNames from 'classnames'

interface SvgImageEditorProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  disableClassName?: string
}

export const SvgImageEditor = (props: SvgImageEditorProps) => {
  const {value, onChange, disabled, disableClassName} = props;
  
  return <div className={styles.container}>
    {!disabled && <Editor height='250px' defaultLanguage='xml' value={value} onChange={(val) => onChange && onChange(val || '')} />}
    {disabled && value && <img src={svgStrToDataUrl(value)} className={classNames([styles.nozzleImg, disableClassName])} />}
    {disabled && !value && <div>No Image</div>}
  </div>
}